import type { BridgeEvents } from './types'

export type Emitter = {
  on<K extends keyof BridgeEvents>(
    event: K,
    handler: (payload: BridgeEvents[K]) => void,
  ): () => void
  emit<K extends keyof BridgeEvents>(event: K, payload: BridgeEvents[K]): void
}

export function createEmitter(): Emitter {
  const handlers: Partial<{
    [K in keyof BridgeEvents]: Set<(payload: BridgeEvents[K]) => void>
  }> = {}

  return {
    on(event, handler) {
      const set =
        handlers[event] ??
        (handlers[event] = new Set() as never)
      ;(set as Set<typeof handler>).add(handler)
      return () => {
        ;(set as Set<typeof handler>).delete(handler)
      }
    },
    emit(event, payload) {
      const set = handlers[event]
      if (!set) return
      for (const h of set as Set<(p: typeof payload) => void>) {
        try {
          h(payload)
        } catch (err) {
          console.error(`bridge: handler for ${event} threw`, err)
        }
      }
    },
  }
}
